var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGoogle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 28,
    width: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.89699102 0 0 0.89699102 1.1560227 2.0565408)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.71 13.32C6.71 11.95 7.08 10.6 7.78 9.43V4.6h-4.83C1.04 7.1 0 10.17 0 13.32c0 3.15 1.04 6.21 2.95 8.71h4.83V17.2c-0.7-1.17-1.07-2.52-1.07-3.88z",
    fill: "#fbbd00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m14.32 20.92-3.35 3.36 3.36 3.36c3.15 0.01 6.22-1.03 8.71-2.95v-4.82h-4.82c-1.18 0.7-2.52 1.07-3.89 1.07z",
    fill: "#0f9d58"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m7.78 17.2-4.83 4.82c0.38 0.5 0.8 0.97 1.24 1.41 1.33 1.33 2.9 2.39 4.64 3.11 1.74 0.72 3.6 1.09 5.48 1.08V20.92C13 20.92 11.7 20.58 10.56 19.93 9.41 19.27 8.45 18.33 7.78 17.2Z",
    fill: "#31aa52"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m28.63 13.31c0-0.87-0.08-1.74-0.23-2.59l-0.13-0.69h-13.95v6.71h6.79c-0.65 1.29-1.66 2.37-2.9 3.11l4.82 4.82c0.5-0.38 0.97-0.8 1.41-1.24 1.33-1.33 2.39-2.9 3.11-4.64 0.72-1.74 1.09-3.6 1.08-5.48z",
    fill: "#3c79e6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m19.69 7.94 0.59 0.59 4.75-4.74-0.59-0.59C23.11 1.86 21.53 0.8 19.8 0.08 18.06-0.64 16.2-1.01 14.32-1L10.96 2.36l3.36 3.36c1 0 1.99 0.19 2.91 0.57 0.92 0.38 1.76 0.94 2.47 1.65z",
    fill: "#cf2d48"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.31 5.71V-1C12.43-1.01 10.57-0.64 8.83 0.08 7.1 0.8 5.52 1.86 4.19 3.19 3.75 3.63 3.34 4.1 2.95 4.6l4.83 4.83C8.45 8.29 9.41 7.35 10.56 6.7 11.7 6.05 13 5.71 14.31 5.71Z",
    fill: "#eb4132"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogle);
export default __webpack_public_path__ + "static/media/google.007e26af407e2211f2b2367fd892478b.svg";
export { ForwardRef as ReactComponent };